import { LoginHintProps } from 'src/common/types';
import { useLogReportedRefreshError } from './useLogReportedRefreshError';
import { useDecideIfLoginIsRequired } from './useDecideIfLoginIsRequired';

export const useWithAuthState = ({
    forceAuth,
    requireMfa,
    emailLoginHint,
}: { forceAuth: boolean; requireMfa: boolean } & LoginHintProps) => {
    const { error, session, status, isAuthenticationDecisionPending } = useDecideIfLoginIsRequired(
        forceAuth,
        requireMfa,
        emailLoginHint
    );

    useLogReportedRefreshError(session);

    if (error) {
        // allow our React error boundaries to handle any errors, should they occur
        // (instead of swallowing promise rejections encountered during useEffect's async calls)
        throw error;
    }

    return { isAuthenticationDecisionPending, status, session };
};
